import type { SLIDER_TYPES } from 'hb-builder/components/UIComponents/page/dynamic/Slider/SliderLayouts/types';

export const getHeadline = (item: any, type: SLIDER_TYPES) =>
  item?.attributes?.dynamicAttributes?.headlines?.[type] || '';
